import { CommonHelperFunctions, ISubscriptionDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import confJson from "../shared/data/conf.json";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

const redirectDomains = confJson.redirectDomainToUrl;

declare let window: any;
export class SubscriptionService {
  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/subscriptions/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async Update(id: string, usr: ISubscriptionDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<ISubscriptionDto, AxiosResponse>(`${backendUrl}/subscriptions/${id}`, usr);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetSubscriptionPlans(): Promise<AxiosResponse> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/subscriptions/subscriptionPlans`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async LoadPlan(planId: string): Promise<AxiosResponse> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/subscriptions/plan/${planId}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
